export default __webpack_public_path__ + "static/media/total_calls.e25d5a94.svg";